export default function () {
    return {
        name: 'Alen React',
        photoURL: './img/user.png',
        email: 'username@gmail.com',
        phone: '+38(050)050 50 50',
        position: 'React developer',
        username: 'admin',
        password: 12345,
        description: [{
                article: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident voluptate asperiores similique quis neque nostrum quia culpa officia sint a laborum dolorem, et dolores!'
            },
            {
                article: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident voluptate asperiores similique quis neque nostrum quia culpa officia sint a laborum dolorem, et dolores! Maiores dolores modi doloribus maxime assumenda molestias quisquam aliquid unde beatae expedita porro asperiores, distinctio mollitia?'
            },
            {
                article: 'Maiores dolores modi doloribus maxime assumenda molestias quisquam aliquid unde beatae expedita porro asperiores, distinctio mollitia?'
            }
        ]
    }
}